import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { DrugInteractionModel } from '../models/DrugInteractionModel';

@Injectable()
export class DrugInteractionSevice {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getDrugInteraction(divisitserial: number,patientcode :string , comCode: string) {
      let params = new HttpParams();
        params = params.append("DIVisitserial", divisitserial);
        params = params.append("PatientCode", patientcode);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<DrugInteractionModel>(this.urlsconfig.WebAPIURL_Test + 'api/DrugInteraction/GetDrugInteraction',options);
    }
    public Adddruginteraction(DrugInteraction: DrugInteractionModel) {
        return this.http.post<DrugInteractionModel>(this.urlsconfig.WebAPIURL_Test + 'api/DrugInteraction/AddDrugInteraction', DrugInteraction);
    }
    public AdddruginteractionImage(DrugInteraction: DrugInteractionModel) {
      return this.http.post<DrugInteractionModel>(this.urlsconfig.WebAPIURL_Test + 'api/DrugInteraction/AddDrugInteractionImage', DrugInteraction);
  }
}
